import React from "react";

export const BackupKeyContext = React.createContext();